import type { PriceChangeRequest, PriceChangeResponse, PricingSearchRequest, PricingSearchResponse, ServiceTypesByZipcodeResponse } from "../../../typings/GetAQuote";
import type { TypeaheadLocationResponse } from "../../../typings/Location";
import { request, requestWithStatus } from "../../api/ApiHelpers";

export async function fetchSearchAddress(url: string, query: string): Promise<TypeaheadLocationResponse> {
    return await requestWithStatus<TypeaheadLocationResponse>({ url, params: { query, typeahead: true } }).then((response) => {
        return response;
    });
}

export async function fetchPricingResults(url: string, queryParamObj: PricingSearchRequest): Promise<PricingSearchResponse> {
    return await requestWithStatus<PricingSearchResponse>({ url, params: queryParamObj }).then((response) => {
        return response;
    });
}

export async function fetchPricingUpdate(url: string, queryParamObj: PriceChangeRequest): Promise<PriceChangeResponse> {
    return await request<PriceChangeResponse>({ url, params: queryParamObj }).then((response) => {
        return response;
    });
}

export async function fetchServiceTypesByZipcode(url: string, zip: string,  latitude: number, longitude: number): Promise<ServiceTypesByZipcodeResponse> {
    const params: any = { 
        postalCode: zip,
        latitude,
        longitude,
    };
    return await requestWithStatus<ServiceTypesByZipcodeResponse>({ url, params }).then((response) => {
        return response;
    });
}
